import React, { Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SRow, SCol, SIcon, SContainer } from '@avalara/skylab-sdk/react';
import { CartInfoContainer, QuantityWrapper } from '../styled/components/cart';
import { getRiskAssessmentSalestax } from '../../lib/side-effects/avatax';
import { getRiskAssessmentPricingData } from '../../lib/helpers';
import { formatPrice } from '../../../shared/helpers';
import { selectState } from '../../selectors';
const CartInfo = () => {
    const dispatch = useDispatch();
    const state = useSelector(selectState);
    const { account, order: { discountCode } } = state;
    const { salestaxDisplayText, subTotal, totalPrice, basePrice, discountAmount, discountPercent, discountName } = getRiskAssessmentPricingData(state);
    useEffect(() => {
        dispatch(getRiskAssessmentSalestax());
    }, [account.accountId, subTotal]);
    const cartInfoTitle = discountCode != null && discountPercent === 100 ? 'Sales tax risk assessment report' : 'Sales tax risk assessment report and consultation';
    return (React.createElement(SContainer, { className: 'pad-all-none' },
        React.createElement(CartInfoContainer, { className: 'pad-top-md pad-left-md pad-right-md pad-bottom-md justify-content-center' },
            React.createElement("div", { id: 'cart-info-header', className: 'pad-bottom-md' }, "Your order"),
            React.createElement(SRow, { className: 'justify-content-space align-items-center cart-info-text pad-all-xs' },
                React.createElement(SCol, { span: 'xl-10 lg-10 6' }, cartInfoTitle),
                React.createElement(SCol, { span: 'xl-2 lg-2 4', className: 'text-right' },
                    React.createElement(QuantityWrapper, null,
                        React.createElement("span", { style: discountPercent && discountPercent > 0 ? { textDecoration: 'line-through' } : {} }, formatPrice(basePrice))))),
            !!discountPercent && discountPercent > 0 &&
                React.createElement(Fragment, null,
                    React.createElement(SRow, { className: 'justify-content-space align-items-center cart-info-text pad-all-xs' },
                        React.createElement(SCol, { span: '8', className: 'hide-overflow' },
                            React.createElement("span", { className: 'pad-right-sm' }, "Discount"),
                            discountName &&
                                React.createElement("span", { className: 'no-wrap', title: discountName },
                                    React.createElement(SIcon, { name: 'tag', "aria-hidden": 'true', className: 'pad-right-xs' }),
                                    discountName)),
                        React.createElement(SCol, { span: '4', className: 'text-right align-self-start' },
                            React.createElement(QuantityWrapper, null,
                                React.createElement("span", null,
                                    "- ",
                                    discountAmount)))),
                    React.createElement(SRow, { className: 'justify-content-space align-items-center cart-info-text pad-all-xs' },
                        React.createElement(SCol, { span: 'xl-10 lg-10 6', className: 'align-self-end' }, "Your price"),
                        React.createElement(SCol, { span: 'xl-2 lg-2 4', className: 'text-right' },
                            React.createElement("hr", { className: 'pad-bottom-sm' }),
                            React.createElement(QuantityWrapper, null,
                                React.createElement("span", null, formatPrice(subTotal)))))),
            React.createElement(SRow, { className: 'justify-content-space align-items-center cart-info-text pad-all-xs' },
                React.createElement(SCol, { span: '4' }, "Sales tax"),
                React.createElement(SCol, { span: '4', className: 'text-right' },
                    React.createElement(QuantityWrapper, null,
                        React.createElement("span", { className: /calculated/i.test(salestaxDisplayText) ? 'text-xs' : '' }, salestaxDisplayText)))),
            React.createElement("hr", null),
            React.createElement(SRow, { className: 'justify-content-space align-items-center cart-info-text font-bold pad-all-xs' },
                React.createElement(SCol, { span: 'xl-4 xl-4 2' }, "Total:"),
                React.createElement(SCol, { id: 'sales-tax-text', span: '4', className: 'text-right' }, formatPrice(totalPrice))))));
};
export default CartInfo;
